import { render, staticRenderFns } from "./nianshenlist.vue?vue&type=template&id=1e043f3b&scoped=true&"
import script from "./nianshenlist.vue?vue&type=script&lang=js&"
export * from "./nianshenlist.vue?vue&type=script&lang=js&"
import style0 from "./nianshenlist.vue?vue&type=style&index=0&id=1e043f3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e043f3b",
  null
  
)

export default component.exports